import { useState, useCallback } from 'react'
import { fetchProcessos } from 'services/MinhaConta//MeusProcessos'
import { userData } from 'services/LoginFunctions'

export function useProcessos(initialFilterVals, initialPagination) 
{
    const [loading, setLoading] = useState(true)
    const [allProcs, setAllProcs] = useState(null)
    const [pagination, setPagination] = useState(initialPagination)
    const [filterVals, setFilterVals] = useState(initialFilterVals)
    const [inputFilters, setInputFilters] = useState(initialFilterVals)

    const handleInputChange  = (e) => 
    {
        const { name, value } = e.target
        setInputFilters(prevFilters => 
        (
            {
                ...prevFilters,
                [name]: value
            }
        ))
    }

    const handlePageChange = (newPage) => 
    {
        setFilterVals(prevFilters => 
        (
            {
                ...prevFilters,
                currentPage: newPage
            }
        ))
        setLoading(true)
    }

    const handleFiltrarClick = () => 
    {
        setFilterVals(() => 
        (
            {
                ...inputFilters,
                currentPage: 1
            }
        ))
        setLoading(true)
    }

    const handleSortChange = (fieldName) => 
    {
        const desc = filterVals["sortBy"] === fieldName? !filterVals["sortDesc"] : true
        setFilterVals((prevFilters) => 
        (
            {
                ...prevFilters,
                currentPage: 1,
                sortBy: fieldName,
                sortDesc: desc
            }
        ))
        setLoading(true)
    }

    const handleSwitchParticip = () => 
    {
        setInputFilters(prevFilters => 
        ({
            ...prevFilters,
            particip: prevFilters.particip === "" ? userData()['matricula'] : ""
        }))
    }

    const fetchData = useCallback(async () => 
    {
        const resp = await fetchProcessos(filterVals)
        setAllProcs(resp.data)
        setPagination(prevPagination => 
        (
            {
                ...prevPagination,
                currentPage: resp.currentPage,
                numPages: resp.numPages,
                itemsPerPage: resp.itemsPerPage,
                totalItems: resp.totalItems
            }
        ))
        setLoading(false)
    }, [filterVals])

    return {
        loading,
        allProcs,
        pagination,
        inputFilters, 
        filterVals,
        handleInputChange,
        handleSortChange,
        handlePageChange,
        handleFiltrarClick,
        handleSwitchParticip,
        fetchData
    }
}
